// extracted by mini-css-extract-plugin
export default {"backdrop":"ConfirmationModal-backdrop___cb5afe93365b6193e29","modal":"ConfirmationModal-modal__d22f340fe91280e760d6"};